import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DataTypePipe } from '../pipe/data-type.pipe';
import { CalendarService } from './calender-service';
import { emitDistinctChangesOnlyDefaultValue } from '@angular/compiler';
import { PersianDatePipe } from '../pipe/persian-data.pipe';

@Injectable({
  providedIn: 'root',
})
export class PrintService {
  constructor(
    private translate: TranslateService,
    private calender: CalendarService
  ) {}

  print(divId: string) {
    let printElement = document.getElementById(divId);
    if (printElement == null) {
      return;
    }
    let printContents = printElement.innerHTML.replaceAll('hidden-in-show', '');
    let popupWin = window.open('', '_blank', 'width=800,height=600');
    if (popupWin == null) {
      return;
    }

    popupWin.document.open();

    let styles = document.querySelectorAll('link[rel="stylesheet"], style');
    let styleLinks = '';

    styles.forEach((style) => {
      styleLinks += style.outerHTML;
    });

    popupWin.document.write(`
      <html dir="rtl" class="light-style layout-navbar-fixed layout-menu-fixed" lang="fa">
        <head>
          <title>Print</title>
          <style>
            div.print-body{
              width: 80mm;
              padding-left: 1.5mm;
              padding-right: 1.5mm;
            }
            .hidden-in-show{
              display:block;
            }
          </style>
          ${styleLinks}
        </head>
        <body class="print-body-body app-root modal-open">
          ${printContents}
        </body>
      </html>`);

    setTimeout(() => {
      popupWin!.print();
      popupWin!.close();
    }, 1000);
  }

  printReport(jsonData, durgStoreName, insuranceName, startDate, EndDate) {
    let popupWin = window.open('', '_blank', 'width=800,height=600');
    if (popupWin == null) {
      return;
    }

    const dataTypePipe = new DataTypePipe(this.translate, this.calender);
    const persianDatePipe = new PersianDatePipe(this.calender);

    let body = ``;

    let index = 0;
    let sum = 0;
    jsonData.forEach((element) => {
      index += 1;

      sum += element['insurancePrice'];
      body += `
        <tr>
          <td>${index}</td>
          <td>${persianDatePipe.transform(element['prescriptionDate'])}</td>
          <td>${element['doctorName']}</td>
          <td>${element['patientName']}</td>
          <td>${element['patientNationalCode']}</td>
          <td>${dataTypePipe.transform(
            element['elementPrice'],
            'price',
            true
          )}</td>
          <td>${dataTypePipe.transform(
            element['paidPrice'],
            'price',
            true
          )}</td>
          <td>${dataTypePipe.transform(
            element['insurancePrice'],
            'price',
            true
          )}</td>
          <td>${dataTypePipe.transform(
            element['shareCurrencyPrice'],
            'price',
            true
          )}</td>
          <td>${dataTypePipe.transform(
            element['insuranceTechnicalRight'],
            'price',
            true
          )}</td>
        </tr>
      `;
    });

    popupWin.document.open();

    let htmlDocuments = `
<!DOCTYPE html>
<html lang="fa" dir="rtl">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>${durgStoreName} داروخانه</title>
    <link rel="stylesheet" href="../../assets/vendor/css/rtl/rtl.css">
    <style>
        body {
            font-family: "primary-font", "segoe ui", "tahoma";
            direction: rtl;
            margin: 0;
            padding: 0;
        }

        .container {
            width: 297mm;
            height: 210mm;
            margin: 20px auto;
            border: 1px solid #000;
            padding: 10px;
        }

        .header {
          text-align: center;
          height: 18mm;
        }
        
        .header .row{
          width:100%
        }
        
        .header .row{
          display: flex;
          justify-content: space-between;
        }

        .header *{
          margin:unset;
        }
        
        .container .body{
            height: 160mm;
        }

        .header h1 {
            font-size: 18px;
            margin: 0;
        }

        table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 20px;
        }
        
        thead,
        tbody>tr>td:first-child{
          background-color: #e7e7e7a3;
        }

        table, th, td {
            border: 1px solid #000;
        }

        th, td {
            padding: 8px;
            text-align: center;
        }

        .footer {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 14px;
            height: 20mm;
            padding-right: 10mm;
            padding-left: 10mm;
        }

        .footer *{
          margin:unset;
          }
        .footer .page-report{
          border:1px solid black;
          }
        .footer .page-report p{
          border-bottom:1px solid black;
          padding-right: 2mm;
          padding-left: 2mm;
          padding-top: 1mm;
          padding-bottom: 1mm;
          }
        .footer .page-report p:last-child{
          border-bottom:unset;
          }
        .signature {
            text-align: left;
            margin-top: 20px;
            border: 1px solid black;
            width: 100mm;
            height: 30mm;
        }
    </style>
</head>
<body>
    <div class="container">
        <div class="header">
          <div class="row">
            <h1>داروخانه ${durgStoreName}</h1>
            <p>https://PendarPharma.com</p>
          </div>
          <div class="row">
            <p> لیست نسخ بیمه ${insuranceName} </p>
            <p>از تاریخ ${startDate} تا تاریخ ${EndDate}</p>
          </div>
        </div>
        <div class="body">
          <table>
            <thead>
              <tr>
                  <th>ردیف</th>
                  <th>تاریخ نسخه</th>
                  <th>کد پزشک</th>
                  <th>نام بیمار</th>
                  <th>کد ملی بیمار</th>
                  <th>جمع کل</th>
                  <th>سهم بیمار</th>
                  <th>سهم سازمان</th>
                  <th>حق ارز</th>
                  <th>حق فنی</th>
              </tr>
            </thead>
            <tbody>
              ${body}
            </tbody>
          </table>
        </div>

        <div class="footer">
            <div class="page-report">
                <p>جمع صفحه: ${dataTypePipe.transform(sum, 'price', true)}</p>
                <p>مانده از صفحه قبل: ${dataTypePipe.transform(
                  0,
                  'price',
                  true
                )}</p>
                <p>جمع کل آخر این صفحه: ${dataTypePipe.transform(
                  sum,
                  'price',
                  true
                )}</p>
            </div>
            <div class="signature">
                <p>مهر و امضا داروخانه</p>
            </div>
        </div>
    </div>
</body>
</html>`;

    console.log(htmlDocuments);
    popupWin.document.write(htmlDocuments);

    // setTimeout(() => {
    //   popupWin!.print();
    //   popupWin!.close();
    // }, 1000);
  }
}
